// External Dependencies:
import React from 'react'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import Image from 'components/Image/Image'

class PostTileVerImageMedium extends React.Component {
	render() {
		let { url, title, author, date, image, imageAlt } = this.props

		return (
			<Link className="post-tile is-vertical is-medium with-image" to={ url }>
				<Image
					thumb={ image.thumb }
					url={ image.url }
					srcset={ image.srcset }
					sizes={ `(max-width: ${siteData.mobile_max_width}) 100vw, 200px` }
					alt={ imageAlt }
					focalPoint={ image.focal_point }
					width={ image.width }
					height={ image.height }
				/>

				<div className="-text">
					<h3 className="-title">{ title }</h3>

					<div className="-author-date">
						<div className="-author">{ author }</div>
						<div className="-date">{ date }</div>
					</div>
				</div>
			</Link>
		)
	}
}

export default PostTileVerImageMedium
